<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane name="LossLegalHousePlan" label="欠费明细">
        <template slot="label">
          <span>
            催费房产
            <el-badge :value="legal_house_obj.total2" ></el-badge>
          </span>
        </template>
        <LegalHousePlan @onAdd="handleAdd" v-if="activeName==='LossLegalHousePlan'" />
      </el-tab-pane>
      <el-tab-pane name="LegalHousePlanTemp" label="草稿">
        <template slot="label">
          <span>
            当期计划
            <el-badge :value="legal_house_obj.count" ></el-badge>
          </span>
        </template>
        <LegalHousePlanTempExcel @onAdd="handleAdd" v-if="activeName==='LegalHousePlanTemp'" :age_type_ids="[1]" />
      </el-tab-pane>
      <el-tab-pane name="LegalHousePlanTemp2" label="草稿">
        <template slot="label">
          <span>
            历史计划
            <el-badge :value="legal_house_obj.count2" ></el-badge>
          </span>
        </template>
        <LegalHousePlanTempExcel @onAdd="handleAdd" v-if="activeName==='LegalHousePlanTemp2'" :age_type_ids="[2,3,4]" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import LossLegalHousePlan from "./LossLegalHousePlan";
import LegalHousePlanTemp from "./LegalHousePlanTemp";
import LegalHousePlanTempExcel from "./LegalHousePlanTempExcel";
import ButlerHttp from "../../common/ButlerHttp";
import {CommonHelp} from "../../common/CommonHelp";
import LegalHousePlan from "./LegalHousePlan";
export default {
  name: "LegalHoseLayout",
  inject:['where','reginWhere'],
  components: {LegalHousePlan, LegalHousePlanTempExcel,LegalHousePlanTemp, LossLegalHousePlan},
  data() {
    return {
      activeName: "LossLegalHousePlan",
      legal_house_obj: {
        total: 0,
        total2: 0,
        count: 0,
        count2: 0,
      },
    };
  },
  mounted() {
    this.handleAdd();
  },
  methods: {
    handleAdd(){
      const that = this;
      let where = {
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id
      }
      ButlerHttp.post("HouseUrgeTempLog/getLegalHouseCount",where,res=>{
        console.log(res.data)
        that.legal_house_obj = res.data;
      })
    }
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.handleAdd();
      },500,that);
    },
    "reginWhere.project_region":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.handleAdd();
      },500,that);
    },
    "reginWhere.project_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.handleAdd();
      },500,that);
    },
    "reginWhere.area_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.handleAdd();
      },500,that);
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/plan/LegalHoseLayout.vue